
export default function DocumentsSection() {
  const verificationMethods = [
    {
      title: 'スマホでスピード本人確認',
      recommended: true,
      icon: 'ri-smartphone-line',
      time: '最短即日',
      description: 'スマホのカメラで撮影するだけ。AIが自動で照合し、最短即日で審査完了。',
      image: 'https://public.readdy.ai/ai/img_res/ff9323d441032f0e802646b12c20498e.jpg',
      steps: ['本人確認書類を撮影', '顔写真を撮影', '自動アップロード'],
    },
    {
      title: '画像アップロード',
      recommended: false,
      icon: 'ri-upload-2-line',
      time: '1〜2営業日',
      description: '書類の画像をアップロードして提出。郵送不要で手軽に完了。',
      image: 'https://readdy.ai/api/search-image?query=laptop%20screen%20showing%20document%20upload%20interface%20with%20drag%20and%20drop%20area%20for%20file%20upload%20clean%20minimal%20white%20background%20with%20soft%20green%20teal%20accent%20modern%20flat%20illustration%20style%20fintech&width=500&height=300&seq=ao-verify2-v2&orientation=landscape',
      steps: ['書類を撮影・スキャン', 'マイページからアップロード', '簡易書留で受け取り'],
    },
  ];

  const documents = [
    {
      category: '本人確認書類（いずれか1点）',
      icon: 'ri-id-card-line',
      items: [
        { name: '運転免許証', note: '表面・裏面の両方' },
        { name: 'マイナンバーカード', note: '表面のみ' },
        { name: 'パスポート', note: '顔写真ページ＋所持人記入欄' },
        { name: '在留カード', note: '表面・裏面の両方' },
      ],
    },
    {
      category: 'マイナンバー確認書類',
      icon: 'ri-file-shield-line',
      items: [
        { name: 'マイナンバーカード', note: '裏面（番号記載面）' },
        { name: 'マイナンバー通知カード', note: '表面' },
        { name: 'マイナンバー記載の住民票', note: '発行から3ヶ月以内' },
      ],
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">本人確認の方法と必要書類</h2>
          <p className="text-gray-600">2つの本人確認方法から選べます</p>
        </div>

        {/* Verification Methods */}
        <div className="grid md:grid-cols-2 gap-6 mb-14">
          {verificationMethods.map((method, i) => (
            <div key={i} className={`relative rounded-2xl overflow-hidden border-2 ${method.recommended ? 'border-teal-400 shadow-lg' : 'border-gray-200'} bg-white`}>
              {method.recommended && (
                <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-teal-500 to-emerald-600 text-white text-center text-xs font-bold py-1.5">
                  <i className="ri-star-fill mr-1"></i>おすすめ
                </div>
              )}
              <div className={`w-full h-[180px] overflow-hidden ${method.recommended ? 'mt-7' : ''}`}>
                <img
                  src={method.image}
                  alt={`DMM FX ${method.title}`}
                  title={`DMM FX本人確認 ${method.title}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                      <i className={`${method.icon} text-teal-600`}></i>
                    </div>
                    {method.title}
                  </h3>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${method.recommended ? 'bg-teal-50 text-teal-700' : 'bg-gray-100 text-gray-600'}`}>
                    {method.time}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-4">{method.description}</p>
                <div className="flex items-center gap-2">
                  {method.steps.map((s, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <span className="text-xs bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1 text-gray-700 whitespace-nowrap">{s}</span>
                      {idx < method.steps.length - 1 && <i className="ri-arrow-right-s-line text-gray-400 text-sm"></i>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Required Documents */}
        <div className="grid md:grid-cols-2 gap-6">
          {documents.map((doc, i) => (
            <div key={i} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-100">
              <h3 className="text-lg font-bold text-gray-900 mb-5 flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                  <i className={`${doc.icon} text-teal-600`}></i>
                </div>
                {doc.category}
              </h3>
              <div className="space-y-3">
                {doc.items.map((item, idx) => (
                  <div key={idx} className="flex items-center justify-between bg-white rounded-lg px-4 py-3 border border-gray-100">
                    <div className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-emerald-500"></i>
                      <span className="text-sm font-medium text-gray-800">{item.name}</span>
                    </div>
                    <span className="text-xs text-gray-500">{item.note}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-teal-50 border border-teal-200 rounded-xl p-5 flex items-start gap-3">
          <i className="ri-lightbulb-flash-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
          <div>
            <h4 className="font-bold text-gray-900 mb-1 text-sm">マイナンバーカードが最も便利！</h4>
            <p className="text-gray-700 text-xs leading-relaxed">
              マイナンバーカードがあれば、本人確認書類とマイナンバー確認書類の両方を1枚で兼ねることができます。スマホでスピード本人確認と組み合わせれば、最短即日で口座開設が完了します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
